import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://relatorios.uzerpass.com.br/api',
});

export default instance;